import { render, staticRenderFns } from "./afterSalesApprovalManage.vue?vue&type=template&id=187511ed&scoped=true&"
import script from "./afterSalesApprovalManage.vue?vue&type=script&lang=js&"
export * from "./afterSalesApprovalManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187511ed",
  null
  
)

export default component.exports